// extracted by mini-css-extract-plugin
export var aboutAuthor = "dW_kP";
export var author = "dW_hB";
export var content = "dW_cz";
export var name = "dW_kN";
export var quote = "dW_kM";